import { isEmptyOrBlank } from "./Validation"

type ParamValue = string | number | boolean

export function urlWithQueryParams(
  url: string,
  params: Record<string, ParamValue | ParamValue[] | undefined>,
) {
  const urlParams = new URLSearchParams()

  for (const [key, value] of Object.entries(params)) {
    if (value == undefined) continue

    if (Array.isArray(value))
      value.forEach(value => urlParams.append(key, String(value)))
    else urlParams.append(key, String(value))
  }

  const queryParams = urlParams.toString()
  return !isEmptyOrBlank(queryParams) ? `${url}?${queryParams}` : url
}
